import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { format } from "date-fns";
import { useFormik } from "formik";
import toast from "react-hot-toast";

import "./createUser.css";
import styles from "../../../../styles/Username.module.css";
import extend from "../../../../styles/Profile.module.css";
import avatar from "../../../../assets/profile.png";

import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import { userFormValidate } from "../../../../helper/validate";
import * as api from "helper/helper";
import convertToBase64 from "../../../../helper/convert";
import LoadingButton from "../LoadingButton/LoadingButton";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";

const CreateUser = forwardRef(({ item, reloadUsuarios }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();

  const [file, setFile] = useState();
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [ciudades, setCiudades] = useState([]);
  const [regiones, setRegiones] = useState([]);
  const [nivelesUsuarios, setNivelesUsuarios] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  /** formik doesn't support file up`load so we need to create this handler */
  const onUpload = async (e) => {
    const base64 = await convertToBase64(e.target.files[0]);
    setFile(base64);
  };

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    formik?.resetForm();
  }, [item]);

  useEffect(() => {
    const newPermissions = PermissionsForSection(Sections.Usuarios);
    setPermissions(newPermissions);

    api
      .ciudades()
      .then((response) => {
        setCiudades([
          { id: 0, nombre: "Selecciona una ciudad..." },
          ...response.data,
        ]);
        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });

    api
      .regiones()
      .then((response) => {
        setRegiones([
          { id: 0, nombre: "Selecciona una ciudad..." },
          ...response.data,
        ]);
        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });

    api
      .departamentos()
      .then((response) => {
        setDepartamentos([
          { id: 0, nombre: "Selecciona un departamento..." },
          ...response.data,
        ]);
        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });

    api
      .nivelesUsuarios()
      .then((response) => {
        setNivelesUsuarios([
          { id: 0, nombre: "Selecciona un nivel..." },
          ...response.data,
        ]);
        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });

    api
      .roles()
      .then((response) => {
        setRoles([{ id: 0, nombre: "Selecciona un rol..." }, ...response.data]);
        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });
  }, []);

  let initialValues = {
    id: 0,
    username: "",
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    fechaNacimiento: "",
    correo: "",
    ciudadId: 0,
    departamentoId: 0,
    rolId: 0,
    nivelUsuarioId: 0,
    activo: true,
  };

  if (!createMode) {
    const fechaNacimiento = format(item.fechaNacimiento, "yyyy-MM-dd");
    initialValues = {
      id: item.id,
      username: item.username,
      nombre: item.nombre,
      apellidoPaterno: item.apellidoPaterno,
      apellidoMaterno: item.apellidoMaterno,
      fechaNacimiento: fechaNacimiento,
      correo: item.correo,
      ciudadId: item.ciudad.id ?? 0,
      departamentoId: item.departamento.id ?? 0,
      rolId: item.rol.id ?? 0,
      nivelUsuarioId: item.nivelUsuario.id ?? 0,
      activo: item.activo,
    };
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: userFormValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      if (values.id === 0) {
        const toastId = toast.loading("Creando Usuario...");
        setIsLoading(true);
        let response = await api.createUsuario(values).catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al crear Usuario. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al crear Usuario.");
          setIsLoading(false);
        });

        setIsLoading(false);
        toast.dismiss(toastId);

        if (!response) return;

        toast.success("Usuario creado.");
        reloadUsuarios();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Usuario...");
        setIsLoading(true);
        const response = await api
          .updateUsuario(values.id, values)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar Usuario.");
          });
        if (!response) return;

        const responseActivo = await api
          .activarUsuario(values.id, values.activo)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar activo Usuario.");
          });

        toast.dismiss(toastId);
        setIsLoading(false);

        if (!responseActivo) return;

        toast.success("Usuario actualizado.");
        reloadUsuarios();

        buttonCancelModalRef.current.click();
      }
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  const buildUsername = (nombre = "", apellidoPaterno = "") => {
    /*
    usar formik.getFieldProps("nombre").value
    esta reportando mal 

    let nombre = formik.getFieldProps("nombre").value.toLowerCase();
    if (nombre.length > 0) {
      nombre = nombre.substring(0, 1);
    }
    let apellidoPaterno = formik
      .getFieldProps("apellidoPaterno")
      .value.toLowerCase();
    */
    let left = nombre.toLowerCase();
    if (left.length > 0) {
      left = left.substring(0, 1);
    }

    let right = apellidoPaterno.toLowerCase();

    const userName = `${left}${right}`;
    formik.setFieldValue("username", userName);
  };

  return (
    <>
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropCrearUsuario"
        hidden
      >
        Abrir Crear Usuario
      </button>
      <div
        className="modal fade modal-lg"
        id="staticBackdropCrearUsuario"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropCrearUsuarioLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {createMode ? "Crear" : "Editar"} Usuario
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form className="row" onSubmit={formik.handleSubmit}>
                <div className="">
                  <div
                    className="profile flex justify-center"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <label htmlFor="profile">
                      <img
                        className={`${styles.profile_img} ${extend.profile_img}`}
                        style={{ height: "100px", width: "100px" }}
                        src={file || avatar}
                        alt="avatar"
                      />
                    </label>

                    <input
                      onChange={onUpload}
                      type="file"
                      id="profile"
                      name="profile"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="row">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Username
                      </label>
                      <input
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.username,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("username")}
                        readOnly
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.username}
                      </div>
                    </div>
                    <div className="col align-self-center">
                      <div id="emailHelp" className="form-text"></div>
                    </div>
                    <div className="col align-container-center">
                      <div className="container-center-horizontal">
                        <div className="form-check form-switch container-center-vertical">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                            {...formik.getFieldProps("activo")}
                            checked={formik.values.activo}
                            disabled={isActiveDisabled}
                          />
                          <span>
                            <label
                              className="form-check-label"
                              htmlFor="flexSwitchCheckDefault"
                            >
                              Activo
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="validationApellidoPaterno"
                    className="form-label"
                  >
                    Nombre
                  </label>
                  <input
                    {...formik.getFieldProps("nombre")}
                    type="text"
                    className={`form-control ${invalidClass(
                      formik.errors.nombre,
                    )}`}
                    id="validationUser"
                    aria-describedby="eeee"
                    onChange={async (e) => {
                      const uppercase = formikExtra.upperCase("nombre", formik);
                      uppercase.onChange(e);

                      let apellidoPaterno =
                        formik.getFieldProps("apellidoPaterno").value;

                      buildUsername(e.target.value, apellidoPaterno);
                    }}
                  />
                  <div className="valid-feedback">Looks good!</div>
                  <div className="invalid-feedback">{formik.errors.nombre}</div>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="validationApellidoPaterno"
                    className="form-label"
                  >
                    Apellido Paterno
                  </label>
                  <input
                    {...formik.getFieldProps("apellidoPaterno")}
                    type="text"
                    className={`form-control ${invalidClass(
                      formik.errors.apellidoPaterno,
                    )}`}
                    onChange={async (e) => {
                      const uppercase = formikExtra.upperCase(
                        "apellidoPaterno",
                        formik,
                      );
                      uppercase.onChange(e);

                      let nombre = formik.getFieldProps("nombre").value;
                      buildUsername(nombre, e.target.value);
                    }}
                    id="validationApellidoPaterno"
                    aria-describedby="eeee"
                  />
                  <div className="valid-feedback">Looks good!</div>
                  <div className="invalid-feedback">
                    {formik.errors.apellidoPaterno}
                  </div>
                </div>

                <div className="mb-3">
                  <label
                    htmlFor="validationApellidoMaterno"
                    className="form-label"
                  >
                    Apellido Materno
                  </label>
                  <input
                    {...formik.getFieldProps("apellidoMaterno")}
                    {...formikExtra.upperCase("apellidoMaterno", formik)}
                    type="text"
                    className="form-control"
                    id="validationApellidoMaterno"
                    aria-describedby="emailHelp"
                  />
                  <div className="valid-feedback">Looks good! WPWPWPW</div>
                  <div className="invalid-feedback">
                    Please choose a username. BOOM
                  </div>
                  <div id="emailHelp11" className="form-text"></div>
                </div>

                <div className="mb-3">
                  <label htmlFor="validationDOB" className="form-label">
                    Fecha de Nacimiento
                  </label>
                  <input
                    type="date"
                    min="1900-01-01"
                    className={`form-control ${invalidClass(
                      formik.errors.fechaNacimiento,
                    )}`}
                    id="validationDOB"
                    aria-describedby="emailHelperwerwer"
                    placeholder="YYYY-MM-DD"
                    {...formik.getFieldProps("fechaNacimiento")}
                    onChange={(e) => {
                      formik.setFieldValue("fechaNacimiento", e.target.value);
                    }}
                  />
                  <div className="valid-feedback">Looks good!</div>
                  <div className="invalid-feedback">
                    {formik.errors.fechaNacimiento}
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="validationEmail" className="form-label">
                    Email
                  </label>
                  <input
                    {...formik.getFieldProps("correo")}
                    {...formikExtra.upperCase("correo", formik)}
                    type="text"
                    className={`form-control ${invalidClass(
                      formik.errors.correo,
                    )}`}
                    id="validationEmail"
                    aria-describedby="emailHelp777"
                  />
                  <div className="valid-feedback">Looks good! WPWPWPW</div>
                  <div className="invalid-feedback">{formik.errors.correo}</div>
                </div>

                <div className="mb-3">
                  <div className="row">
                    <div className="col align-self-start">
                      <label htmlFor="exampleDataList" className="form-label">
                        Ciudad
                      </label>

                      <select
                        className={`form-control ${invalidClass(
                          formik.errors.ciudadId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("ciudadId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "ciudadId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {ciudades.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.ciudadId}
                      </div>
                    </div>
                    <div className="col align-self-end">
                      <label htmlFor="exampleDataList" className="form-label">
                        Departamento
                      </label>
                      <select
                        className={`form-control ${invalidClass(
                          formik.errors.departamentoId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("departamentoId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "departamentoId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {departamentos.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.departamentoId}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="row">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Rol
                      </label>
                      <select
                        className={`form-control ${invalidClass(
                          formik.errors.rolId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("rolId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "rolId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {roles.map((item) => {
                          return <option value={item.id}>{item.nombre}</option>;
                        })}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.rolId}
                      </div>
                    </div>
                    <div className="col align-self-end">
                      <label htmlFor="exampleDataList" className="form-label">
                        Nivel Usuario
                      </label>
                      <select
                        className={`form-control ${invalidClass(
                          formik.errors.nivelUsuarioId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("nivelUsuarioId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "nivelUsuarioId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {nivelesUsuarios.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.nivelUsuarioId}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={buttonCancelModalRef}
              >
                Cancelar
              </button>
              <LoadingButton
                style={{ height: "38px" }}
                onClick={(e) => {
                  formik.handleSubmit();
                }}
                text={"Guardar"}
                loadingText={"Guardando..."}
                isLoading={isLoading}
                hidden={!permissions.canEdit}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default CreateUser;
